import { fetchAsyncData } from 'components.modules.gen/placeholder-dataurl/fetchDataAsync.js';
import { IApiAdTargeting } from 'redux-state/advertisement/types.js';
import { IPageConfig } from 'redux-state/layout/types.page.js';
import { messageLog } from 'utilities/helpers/logger/message-logger.js';
import { objectAssignTypeSafety } from 'utilities/helpers/objects.js';

export const getTargetedAdsUrl = async (
  adConfig: IPageConfig<'Raw'>['adConfig'],
): Promise<IPageConfig<'Raw'>['adConfig']> => {
  const path = adConfig.targeting?.dynamicDataUrl;
  if (path) {
    messageLog.error('Requesting Targeting Data');
    const result = await fetchAsyncData<IApiAdTargeting[]>({ url: path });
    if (result.responseOK) {
      const mergedTargetedData = [...(adConfig.targeting?.staticData ?? []), ...result.jsonData];
      const mergedTargeted = objectAssignTypeSafety(adConfig.targeting, { staticData: mergedTargetedData });
      const mergedAds = objectAssignTypeSafety(adConfig, { targeting: mergedTargeted });
      return mergedAds;
    } else {
      console.error(`Unable to get targeting ads data ${path}`);
      return adConfig;
    }
  }
  return adConfig;
};
